import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#6366f1', // Vibrant Indigo
          colorSuccess: '#10b981', // Emerald green
          colorWarning: '#f59e0b', // Amber yellow
          colorError: '#f43f5e', // Rose red
          colorInfo: '#06b6d4', // Cyan blue
          borderRadius: 12,
          fontFamily: '"Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        },
        components: {
          Button: {
            borderRadius: 8,
            controlHeight: 40,
            fontWeight: 600,
          },
          Card: {
            borderRadiusLG: 16,
          },
          Input: {
            controlHeight: 40,
            borderRadius: 8,
          },
          Select: {
            controlHeight: 40,
            borderRadius: 8,
          },
          Table: {
            borderRadiusLG: 12,
          }
        }
      }}
    >
      <App />
    </ConfigProvider>
  </React.StrictMode>
);
